module.exports = __webpack_public_path__ + "img/ape-constructor-in-wallet.68fe6ee1.svg";